import React from 'react';
import './ButtonSelect.scss';

import actClose from '../../assets/icons/act_close.svg';
import actOpen from '../../assets/icons/act_open.svg';

interface ButtonSelectProps {
  onPressBtn: any,
  isOpen?: boolean
}

const ButtonSelect: React.FC<ButtonSelectProps> = ({onPressBtn, isOpen}) => (
  <div className="container-btn-select">
    <button className="btn-tertiary btn-select" onClick={onPressBtn}>
      {isOpen ? 'Ver menos' : 'Ver más'}
      <img src={isOpen ? actClose : actOpen} alt="Icono abrir"/>
    </button>
  </div>
);

export default ButtonSelect;